import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

interface CapitalDepositMandateePropsIntroPage {
  title: string;
  description: string;
  ctaLocale: string;
  onNext: () => void;
}

const CapitalDepositMandateeIntroPage: FC<
  CapitalDepositMandateePropsIntroPage
> = ({ ctaLocale, description, onNext, title }) => (
  <Flex alignItems="start" flexDirection="column" paddingTop="space-40">
    <Heading marginBottom="space-16" size="lg">
      {title}
    </Heading>

    <Text marginBottom="space-64">{description}</Text>

    <Button isExpanded onClick={onNext}>
      {ctaLocale}
    </Button>
  </Flex>
);

export default CapitalDepositMandateeIntroPage;
